import React from "react";

import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

export const InputTextList = (props) => {
    const handleRemoveClick = (index) => {
        const _items = [...props.value];
        _items.splice(index, 1);
        props.onChange(_items);
    };

    const handleAddClick = () => {
        const _items = [...props.value, ""];
        props.onChange(_items);
    };

    const onListInputChange = (e, index) => {
        const val = e.target?.value || e.value || "";
        const _items = [...props.value];
        _items[index] = val;
        props.onChange(_items);
    };

    return (
        <div>
            {props.value.map((item, index) => (
                <div key={`grid_${props.id}[${index}]`} id={`grid_${props.id}[${index}]`} className="grid">
                    <div id={`input_${props.id}[${index}]`} className="col-9">
                        <InputText id={`${props.id}[${index}]`} value={item} onChange={(e) => onListInputChange(e, index)} readOnly={props.readOnly} />
                    </div>
                    <div id={`btn_${props.id}[${index}]`} className="col-3">
                        {props.value.length !== 1 && <Button disabled={props.readOnly} id={`remBtn_${props.id}[${index}]`} icon="pi pi-minus" className="p-button-warning mr-1" onClick={() => handleRemoveClick(index)} />}
                        {props.value.length - 1 === index && <Button disabled={props.readOnly} id={`addBtn_${props.id}[${index}]`} icon="pi pi-plus" className="p-button" onClick={() => handleAddClick()} />}
                    </div>
                </div>
            ))}
        </div>
    );
};
